<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 10 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.09173 8.49765C0.643853 8.09983 0.643853 7.40017 1.09173 7.00235L8.33591 0.567842C8.98089 -0.00505098 10 0.45282 10 1.3155L10 14.1845C10 15.0472 8.98089 15.5051 8.33591 14.9322L1.09173 8.49765Z" :fill="fill"/>
  </svg>
</template>

<script>
export default {
  name: 'ScrollArrowLeft',
  props: {
    width: {
      type: String,
      required: false,
      default: '10'
    },
    height: {
      type: String,
      required: false,
      default: '16'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#222222'
    },
  },
};

</script>
